import { render, staticRenderFns } from "./similarActive.vue?vue&type=template&id=272e1163&scoped=true&"
import script from "./similarActive.vue?vue&type=script&lang=js&"
export * from "./similarActive.vue?vue&type=script&lang=js&"
import style0 from "./similarActive.vue?vue&type=style&index=0&id=272e1163&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272e1163",
  null
  
)

export default component.exports